import React from 'react';
import MultiPage from './MultiPage';
import EditableText from './EditableText';
import { buildCommentSections } from './commentsSections';

export default function WordsOfWisdomPage({ data, personName, startPageNumber, reportType = 'standard' }) {
  const header = (
    <>
      <h2 className="pdf-section-heading pdf-section-heading--numbered">
        {/* Trend report inserts Key Trends (6) and the Score-shift Appendix (8),
            shifting Words of Wisdom from 7 to 9. */}
        <span className="pdf-section-heading__badge">{reportType === 'trend' ? 9 : 7}</span>
        <EditableText
          as="span"
          path="wordsOfWisdom.sectionHeading"
          variant="inline"
          stripInlineWrap
        />{' '}
        <EditableText
          as="span"
          style={{ fontSize: '14px', fontWeight: 'normal' }}
          path="wordsOfWisdom.sectionSubtitle"
          variant="inline"
          stripInlineWrap
        />
      </h2>
      <EditableText
        as="p"
        className="pdf-body-text"
        path="wordsOfWisdom.introLead"
        variant="inline"
        stripInlineWrap
      />
      <EditableText
        as="p"
        className="pdf-body-text"
        path="wordsOfWisdom.question"
        variant="inline"
        stripInlineWrap
      />
    </>
  );

  return (
    <MultiPage
      header={header}
      items={buildCommentSections(data, 'wordsOfWisdom')}
      startPageNumber={startPageNumber}
      personName={personName}
      sliceKey="wordsOfWisdom"
      sectionKey="wordsOfWisdom"
    />
  );
}
